module.exports = __webpack_public_path__ + "static/media/calendar-dark-blue.8f5c8785.svg";